
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"active-highlight",attrs:{"d":"M14.647 15.597H9.353a.724.724 0 00-.723.723v1.623c0 .4.324.724.723.724h5.294a.724.724 0 00.723-.724V16.32a.724.724 0 00-.723-.723zm-.207 2.14H9.56v-1.21h4.88v1.21z","fill":"#E2E4EC"}}),_c('path',{attrs:{"d":"M23.765 11.576l.007-.004-3.488-6.895a1.639 1.639 0 00-1.47-.904h-.662v-.641a.465.465 0 00-.465-.465H6.313a.465.465 0 00-.465.465v.641h-.663c-.624 0-1.187.346-1.47.904L.229 11.572l.007.004a1.62 1.62 0 00-.235.843v7.284c0 .899.73 1.63 1.629 1.63h20.742A1.63 1.63 0 0024 19.702V12.42a1.62 1.62 0 00-.235-.843zm-5.613-6.77h.663a.61.61 0 01.547.337l2.856 5.647h-1.942V9.052a.465.465 0 00-.465-.465h-.576V6.092a.465.465 0 00-.465-.465h-.618v-.82zm1.194 4.711v1.273h-2.454c-.422 0-.806.248-.979.632l-.67 1.486a.04.04 0 01-.036.023H8.793a.04.04 0 01-.036-.023l-.67-1.486a1.075 1.075 0 00-.978-.632H4.654V9.517h14.692zM6.778 3.597h10.444v2.03H6.778v-2.03zm11.527 2.96v2.03H5.695v-2.03h12.61zM4.638 5.143a.61.61 0 01.547-.336h.663v.82H5.23a.465.465 0 00-.465.465v2.495h-.576a.465.465 0 00-.465.465v1.738H1.782l2.856-5.647zM22.371 20.3H1.629a.596.596 0 01-.595-.596V12.42c0-.329.267-.596.595-.596h5.48c.015 0 .03.01.035.024l.67 1.486c.174.384.557.632.979.632h6.414c.421 0 .805-.248.979-.632l.67-1.486a.04.04 0 01.035-.024h5.48c.328 0 .595.267.595.596v7.284a.596.596 0 01-.595.596z","fill":"#00003C"}})])
          )
        }
      }
    